import React, { useState } from "react";
import {
  makeStyles,
  Switch,
  Tag,
  Text,
  tokens,
  typographyStyles,
} from "@fluentui/react-components";
import { getRemovalChipLabel } from "src/features/selectors";
import { StyleChip } from "../style-chip";
import "./ReviewHeader.css";

const useStyles = makeStyles({
  heading: typographyStyles.subtitle1,
  toggleLabel: {
    color: tokens.colorNeutralForeground1,
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightRegular,
    lineHeight: tokens.lineHeightBase100,
  },
});

export interface ReviewHeaderProps {
  ignoreParagraphs?: boolean;
  loading?: boolean;
  selectedCharacterStyleFilter?: string | null;
  selectedGroupFilter?: string | null;
  selectedStyleFilter?: string | null;
  setIgnoreParagraphs?: (ignore: boolean) => void;
  onClearCharacterStyle: () => void;
  onClearGroup: () => void;
  onClearStyle: () => void;
}

export function ReviewHeader({
  loading,
  ignoreParagraphs,
  selectedCharacterStyleFilter,
  selectedGroupFilter,
  selectedStyleFilter,
  onClearCharacterStyle,
  onClearGroup,
  onClearStyle,
  setIgnoreParagraphs,
}: ReviewHeaderProps) {
  const styles = useStyles();

  const charFilterLabel = selectedCharacterStyleFilter
    ? (getRemovalChipLabel(selectedCharacterStyleFilter) ?? selectedCharacterStyleFilter)
    : null;

  return (
    <div className="review-header">
      <div className="review-header-content">
        <div className="review-header-title">
          <Text className={styles.heading}>Review Styling</Text>
        </div>
        <div className="review-header-toggle">
          <div className="review-header-toggle-content">
            <Text className={styles.toggleLabel}>Ignore</Text>
            <StyleChip className="review-header-toggle-content-stylechip" ignored>
              p
            </StyleChip>
          </div>
          <Switch
            checked={ignoreParagraphs}
            onChange={(_, d) => setIgnoreParagraphs?.(d.checked)}
          />
        </div>
      </div>
      {!loading && (
        <div className="review-header-filters">
          {charFilterLabel && (
            <Tag appearance="brand" dismissible dismissIcon={{ onClick: onClearCharacterStyle }}>
              {charFilterLabel}
            </Tag>
          )}
          {selectedGroupFilter && (
            <Tag appearance="brand" dismissible dismissIcon={{ onClick: onClearGroup }}>
              {selectedGroupFilter}
            </Tag>
          )}
          {selectedStyleFilter && (
            <Tag appearance="brand" dismissible dismissIcon={{ onClick: onClearStyle }}>
              {selectedStyleFilter}
            </Tag>
          )}
        </div>
      )}
    </div>
  );
}
